import { reflow } from '../util/dom';

/**
 * Drive an enter transition: paint the element in its closed state, then add `openClass` on the
 * next frame so CSS transitions run from a known starting point.
 */
export function enter(node: HTMLElement, openClass = 'is-open'): void {
  node.classList.remove(openClass);
  reflow(node);
  requestAnimationFrame(() => node.classList.add(openClass));
}

/**
 * Drive a leave transition: remove `openClass`, then call `done` once the transition on
 * `node` ends. A timeout backstops the case where no transition runs (reduced motion, hidden).
 */
export function leave(node: HTMLElement, openClass = 'is-open', done?: () => void, fallbackMs = 400): void {
  node.classList.remove(openClass);
  let settled = false;
  const finish = () => {
    if (settled) return;
    settled = true;
    node.removeEventListener('transitionend', onEnd);
    clearTimeout(timer);
    done?.();
  };
  const onEnd = (event: TransitionEvent) => {
    if (event.target === node) finish();
  };
  node.addEventListener('transitionend', onEnd);
  const timer = setTimeout(finish, fallbackMs);
}
